import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import Alert from 'reactstrap/lib/Alert';
import { Link } from 'react-router-dom';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';

import { receiveTickets } from '@ttstr/actions';
import { Container, LoadingSpinner, Masonry, useIntl, ContentrArea } from '@ttstr/components';
import { AppState } from '@ttstr/reducers';
import { useActions, useShallowEqualSelector } from '@ttstr/utils';

const TicketListing: React.FC = () => {
  const { t } = useTranslation();
  const { loading, tickets } = useShallowEqualSelector(mapStateToProps);
  const { receiveTickets } = useActions(mapDispatchToProps);
  const { language } = useIntl();

  React.useEffect(() => {
    receiveTickets();
  }, [language]);

  return (
    <article className="ticket-listing">
      <Helmet>
        <title>{t(`TICKETLISTING.TITLE`)}</title>
        <body className="ticket-listing-page inverse-navbar" />
      </Helmet>
      {/* <Container fluid className="header-image" /> */}

      <Container className="listing-filter-buttons-container">
        <img src={require('./assets/images/tr_header.jpg')} alt="" className="img-fluid mt-3" />

        <ContentrArea id="before-ticket-listing" />

        <h5>PROGRAMM FILTERN:</h5>
        <Row className="mb-0 d-flex justify-items-center justify-content-center listing-buttons-container">
          <Col className="mt-2 col-12 col-md-3">
            <Link to="/tickets?tagId=9292" className="btn btn-lg btn-block btn-outline-dark btn-tickets h-100">
              {'Das ist alles Teil der Show'}
            </Link>
          </Col>
          <Col className="mt-2 col-12 col-md-3">
            <Link to="/tickets?tagId=9314" className="btn btn-lg btn-block btn-outline-dark btn-tickets h-100">
              {'Schund & Asche'}
            </Link>
          </Col>
          <Col className="mt-2 col-12 col-md-3">
            <Link to="/tickets?tagId=9303" className="btn btn-lg btn-block btn-outline-dark btn-tickets h-100">
              {'Talk ohne Gast'}
            </Link>
          </Col>
          <Col className="mt-2 col-12 col-md-3">
            <Link to="/tickets?tagId=9320" className="btn btn-lg btn-block btn-outline-dark btn-tickets h-100">
              {'Aufzeichnung TV Sendung'}
            </Link>
          </Col>
        </Row>
      </Container>

      <Container className="list-page mt-2 mb-5 p-0">
        <Container className="list-page py-5">
          {loading ? ( // if loading
            <LoadingSpinner label={t(`LOADING.TICKETS`)} />
          ) : tickets.length === 0 ? ( // if no tickets
            <Alert color="info">{t(`MASONRY.NO_ITEMS`)}</Alert>
          ) : (
            // else show tickets
            <Masonry
              id="ticket-listing"
              products={tickets}
              type="list"
              filters={['fulltext']}
              showTitle
              showCity
              showLocation
              showTags
            />
          )}
        </Container>

        <ContentrArea id="after-ticket-listing" />
      </Container>
    </article>
  );
};

const mapStateToProps = (state: AppState) => {
  const { tickets, loading } = state.Tickets;
  return {
    tickets,
    loading,
  };
};

const mapDispatchToProps = {
  receiveTickets,
};

export default React.memo(TicketListing);
